const components = {
    HOME: 'Home',
    CATALOG: 'catalog',
    DELIVERYNOTERETRIEVAL: 'deliverynoteretrieval',
    ORDERHISTORY: 'orderHistory',
    ORDERVISIBILITY: 'orderVisibility',
    RMAHISTORY: 'rmaHistory',
    USER: 'User',
    PRODUCTDETAILS: 'productdetails',
    CART: 'cart',
    RETURNCART: 'returnCart',
    MANAGETEMPLATES: 'manageTemplates',
    MANAGETEMPLATEDETAILS: 'manageTemplateDetails',
    ORDERDETAILS: 'orderdetails',
    CHECKOUT: 'checkout',
    INVOICEHISTORY: 'invoiceHistory',
    ORDERCONFIRMATION: 'orderconfirmation',
    INVENTORYCHECKIN: 'inventorycheckin',
    INVENTORYCHECKOUT: 'inventorycheckout',
    INVENTORY: 'inventory',
    NOTFOUND: 'NotFound',
    SCANDASHBOARD: 'scandashboard',
    CYCLECOUNT: 'cycleCount',
    MANAGEFOUND: 'managefound',
    MANAGEMISSING: 'manageMissing',
    FORGOTPASSWORD: 'forgotpassword',
    REQUESTACCESS: 'requestAccess',
    SUPPORTPAGE: 'supportpage',
    ACCOUNTFINANCIALINFO: 'accountfinancialinformation',
    USERGUIDES: 'userGuides',
    CONTACTUS: 'contactUs',
    FINDMYSALESREP: 'findMySalesRep',
    POPENDING: 'popending',
    REPORTORDERDISCREPANCY: 'reportOrderDiscrepancy',
    BILLANDREPLACE: 'billAndReplace',
    CONSIGNMENTADD: 'consignmentAdd',
    DRAFTORDERS: 'draftOrders',
    TRANSACTION: 'transaction',
    SAMPLEFROMCONSIGNMENT: 'sampleFromConsignment',
    SAMPLESHIPTOACCOUNT: 'sampleShipToAccount',
    RMAREQUEST: 'rmarequest',
    RMADETAIL: 'rmaDetail',
    CREATERMA: 'rmaInstallBase',
    TERMSANDCONDITIONS: 'termsAndConditions',
    HELP: 'help',
    FAQ: 'faqs',
    RETURNSPOLICY: 'returnsPolicy',
    PRIVACYPOLICY: 'privacyPolicy',
    INVENTORYSPECIALCHECKIN: 'inventorySpecialCheckin',
    RETURNHISTORY: 'returnHistory',
    WARRANTYDASHBOARD: 'warrantyDashboard',
    NEWWARRANTYCLAIM: 'newWarrantyClaim',
    TRAINING: 'training',
    CLAIMSUBMISSION: 'claimSubmission',
    WARRANTYCLAIMDETAILS: 'warrantyClaim',
    WARRANTYREPORTING: 'warrantyReporting',
    CLAIMAUTHORIZATION: 'claimAuthorization',
    OUTSTANDINGINVOICES: 'outstandingInvoices',
    ITCINVOICEHISTORY: 'ITCInvoiceHistory',
    DISPUTES: 'disputes',
    AGEINGSUMMARY: 'ageingSummary',
    ITCHISTORYREPORT: 'ITCHistoryReport',
    ITCACCOUNTSTATEMENT: 'ITCAccountStatement',
    DISPUTEDETAILS: 'disputeDetails',
    ITCPAYMENTUSAGEDETAIL: 'ITCPaymentUsageDetail',
    SALESOUTDASHBOARD: 'salesOutDashboard',
    ACCOUNTINVOICEDETAIL: 'accountInvoiceDetail',
    RAISEDISPUTE: 'raiseDispute',
    MANAGESUBMISSIONS: 'manageSubmissions',
    ENDCUSTOMER: 'endCustomer',
    RETURNCHECKOUT: 'returnCheckout',
    SUBMISSIONDETAIL: 'submissionDetail',
    CUSTOMERADMIN: 'customerAdmin',
    SALESOUTRECORD: 'salesOutRecord',
    SUBMISSIONACCURACY: 'submissionAccuracy',
    INVENTORYRECORD: 'inventoryRecord',
    ENDCUSTOMERRECORD: 'endCustomerRecord',
    SUBMISSIONSTATUSREPORT: 'submissionStatusReport',
    SERVICEREQUEST: 'serviceRequest',
    SERVICEREQUESTDETAILS: 'serviceRequestDetails',
    REGISTERCONSUMPTION: 'registerConsumption',
    CONSUMPTIONSUMMARY: 'consumptionSummary',
    REPORTSTOCKDISCREPANCY: 'reportStockDiscrepancy',
    REPORTDISCREPANCYSUMMARY: 'reportStockDiscrepancySummary',
    ORDERSPENDINGAPPROVAL: 'ordersPendingApproval',
    EQUIPMENTOVERVIEW: 'equipmentOverview',
    EQUIPMENTDETAILS: 'equipmentDetails',
    ACUTECAREMONITORING: 'acuteCareMonitoring',
    NEWSERVICEREQUEST: 'newServiceRequest',
};

export default (state = 'HOME', action = {}) => components[action.type] || state;
